module.exports = __webpack_public_path__ + "img/sign.3badc940.svg";